import axiosClient from "utils/axios";
import type { ApiResponse } from "../../../types/api.types";
import type {
  WorkOrderSubcontract,
  CreateWorkOrderSubcontractPayload,
  UpdateWorkOrderSubcontractPayload,
  CompleteWorkOrderSubcontractPayload,
} from "features/WorkOrders/types/work-order.types";

export const getWorkOrderSubcontracts = async (workOrderId: number) => {
  try {
    const response = await axiosClient.get<ApiResponse<WorkOrderSubcontract[]>>(
      `/work-orders/${workOrderId}/subcontracts`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching work order subcontracts:", err);
    throw err;
  }
};

export const createWorkOrderSubcontract = async (
  workOrderId: number,
  payload: CreateWorkOrderSubcontractPayload,
) => {
  try {
    const response = await axiosClient.post<ApiResponse<WorkOrderSubcontract>>(
      `/work-orders/${workOrderId}/subcontracts`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error creating work order subcontract:", err);
    throw err;
  }
};

export const updateWorkOrderSubcontract = async (
  workOrderId: number,
  subcontractId: number,
  payload: UpdateWorkOrderSubcontractPayload,
) => {
  try {
    const response = await axiosClient.put<ApiResponse<WorkOrderSubcontract>>(
      `/work-orders/${workOrderId}/subcontracts/${subcontractId}`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error updating work order subcontract:", err);
    throw err;
  }
};

export const completeWorkOrderSubcontract = async (
  workOrderId: number,
  subcontractId: number,
  payload: CompleteWorkOrderSubcontractPayload,
) => {
  try {
    const response = await axiosClient.post<ApiResponse<WorkOrderSubcontract>>(
      `/work-orders/${workOrderId}/subcontracts/${subcontractId}/complete`,
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error completing work order subcontract:", err);
    throw err;
  }
};

export const cancelWorkOrderSubcontract = async (
  workOrderId: number,
  subcontractId: number,
) => {
  try {
    const response = await axiosClient.post<ApiResponse<WorkOrderSubcontract>>(
      `/work-orders/${workOrderId}/subcontracts/${subcontractId}/cancel`,
      {},
    );
    return response.data;
  } catch (err) {
    console.warn("Error cancelling work order subcontract:", err);
    throw err;
  }
};

export const deleteWorkOrderSubcontract = async (
  workOrderId: number,
  subcontractId: number,
) => {
  try {
    const response = await axiosClient.delete<ApiResponse<WorkOrderSubcontract>>(
      `/work-orders/${workOrderId}/subcontracts/${subcontractId}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error deleting work order subcontract:", err);
    throw err;
  }
};
